/**
 * Module for the Experience Page sidebar navigation.
 * It is built to be refactored easily and reused on other pages.
 */
SC.sidebar_nav = (function () {
  var api = {};

  // Vars for Sidebar Nav
  var currentScrollY;
  var initializeNavScrollY;
  var $lastSection;
  var $navLinks;
  var $findAClass;
  var $peopleSection;
  var prefix;
  var rendering;
  var $sections;

  // Var for CTA button
  var landingOffset;

  /**
   * init
   * Initialization function which runs at object instantiation time.
   * @returns {void}
   */
  function init() {
    // If this is not the New Rider Experience page, return.
    if (!$('body').hasClass('newrider_experience')) {
      return;
    }

    // Prefix for the New to Soul section elements.
    prefix = 'new-to-soul';

    // The container for the nav links.
    $navLinks = $('.' + prefix + '__nav__link-container');

    // Set all of the container divs that represent menu items.
    $sections = $('.' + prefix + '__section');

    // Number of pixels the window has been scrolled
    currentScrollY = $(this).scrollTop();

    // Number of pixels to scroll before showing nav.
    initializeNavScrollY = $(window).height() / 2;

    // Set the last container div on the page.
    $lastSection = $sections.last();

    // Boolean that determines if section is being updated or not.
    rendering = false;

    // New Soul Variation B Styles
    $findAClass = $('.find-a-class-fixed-button');

    // Verify that variation has a Find a Class button to initialize
    if (typeof $findAClass.offset() !== 'undefined') {
      $peopleSection = $('.' + prefix + '__section__people-background');
      toggleFindClassButton();
    }

    // Get the start of experience page offset to get from where to start transformating button
    landingOffset = $('#' + prefix + '__landing').offset().top;

    setupEvents();
  }

  /**
   * setupEvents
   * Sets the initial active section and binds the scroll event.
   * @returns {void}
   **/
  function setupEvents() {
    // Set the initial active section.
    updateCurrentSection();

    // Update the active section as a user scrolls.
    $(window).on('scroll', onScroll);
    $('.' + prefix + '__nav__link').on('click keyup', SC.utils.ui.handleScrollEvent);

    if (typeof $findAClass.offset() !== 'undefined') {
      // mParticle log Events - Click Find a Class on the New To Soul main content section.
      $findAClass.on('click', function () {
        var sectionName = getCurrentSectionName();
        SC.analytics.mp.sendEvent('Click Find A Class', 'navigation', {'Location': sectionName}, sectionName);
      });
    }
  }

  /**
   * Scroll Event Handler.
   * Sets the current scroll position so it can request an update.
   * If its not already requesting, update the nav.
   * @returns {void}
   */
  function onScroll() {
    currentScrollY = window.pageYOffset;

    if (!rendering) {
      requestAnimationFrame(updateCurrentSection);
    }

    if (typeof $findAClass.offset() !== 'undefined') {
      // Transform CTA button to wider style
      resizeFindClassButton();

      // Hide/Show Button div of New Soul Variation B Styles
      toggleFindClassButton();
    }

    rendering = true;
  }

  /**
   * Function that gets the action section and keeps req
   * @returns {void}
   */
  function updateCurrentSection() {
    // Reset the tick so we capture the next scroll event
    rendering = false;

    // If the current scroll position is past the initialize point start, show the nav.
    (currentScrollY > initializeNavScrollY) ? showNavMenu() : hideNavMenu();

    // Hide the nav before the last section overlaps.
    if (
      $lastSection.offset().top <= ($navLinks.offset().top + $navLinks.outerHeight())
            && ($lastSection.offset().top + $lastSection.outerHeight()) > $navLinks.offset().top
    ) {
      hideNavMenu();
    }

    // Check the position of each of the divs compared to the windows scroll position.
    updateNavCSS();
  }

  /**
   * Show the nav container.
   * @returns {void}
   */
  function showNavMenu() {
    $('.' + prefix + '__nav-container').addClass(prefix + '__nav-container--active');
  }

  /**
   * Hide the nav container.
   * @returns {void}
   */
  function hideNavMenu() {
    $('.' + prefix + '__nav-container').removeClass(prefix + '__nav-container--active');
  }

  /**
   * Function to shrink and widen 'Find a Class' CTA Button
   * @returns {void}
   */
  function resizeFindClassButton() {
    if (currentScrollY >= landingOffset) {
      $findAClass.addClass('new-to-soul__find-a-class-wide');
    } else {
      $findAClass.removeClass('new-to-soul__find-a-class-wide');
    }
  }

  /**
   * Function to make the 'Find a Class' CTA Button disappear before the Riders White Section
   * @returns {void}
   */
  function toggleFindClassButton() {
    var isBeforeWhtSection = ($peopleSection.offset().top + $peopleSection.outerHeight()) >= ($findAClass.offset().top + $findAClass.outerHeight());

    if (isBeforeWhtSection) {
      // If the current scroll position is past the initialize point start, show the button.
      $('.' + prefix + '__find-a-class').addClass(prefix + '__find-a-class--active');
    } else {
      $('.' + prefix + '__find-a-class--active').removeClass(prefix + '__find-a-class--active');
    }
  }

  /**
   * Function to update the nav CSS based on the current section.
   * @returns {void}
   */
  function updateNavCSS() {
    $sections.each(function () {
      var $section = $(this);

      // If the section is past the top of the nav,
      // Remove the old active section and add to the new current section.
      if ($section.offset().top < $navLinks.offset().top) {
        $('.' + prefix + '__nav__item').removeClass(prefix + '__nav__item--active');
        $('#' + $section.attr('id') + '__nav').addClass(prefix + '__nav__item--active');
      }
    });
  }

  /**
   * Function to get the current section name value in the New To Soul Page.
   * @returns {string} sectionName
   */
  function getCurrentSectionName() {
    var sectionName = $('.new-to-soul__nav__item--active').find('a').html();

    switch (sectionName) {
    case 'Soul':
      return 'New Rider Experience Section';
    case 'Classes':
      return 'New Rider Class Section';
    case 'Instructors':
      return 'New Rider Instructor Section';
    case 'People':
      return 'New Rider Riders Section';
    default:
      return 'New Rider Start Your Journey Section';
    }
  }

  init();

  return api;
})();
